<template>
  <div>
    <transition name="fade">
      <div v-if="$parent.showPopup" class="popup">
        <div @click="$parent.showPopup = false" class="offclick"></div>
        <div class="holder">
          <slot></slot>
        </div>
        <div v-if="loading" class="full-btn error">
          <img class="loader" src="@/assets/img/loader.gif" />
        </div>
        <transition name="fade">
          <div v-if="error" class="full-btn error">{{ error }}</div>
        </transition>
        <transition name="fade">
          <div v-if="save && !loading" @click="$parent.save" class="full-btn">
            Save
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "popup",
  props: ["save", "error", "loading"],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(53, 73, 94, 0.75);
}

.popup .close {
  position: fixed;
  top: 0;
  left: 0;
  height: 100px;
  width: 100px;
  background-color: #ed3a4a;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  margin: 0;
}

.popup .close span {
  color: white;
  margin: 0;
  font-size: 80px;
}

.offclick {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
}

.holder {
  position: relative;
  z-index: 2;
  padding: 50px;
  width: 600px;
  background-color: white;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  max-height: 600px;
  overflow: auto;
}

.not_found .holder {
  max-height: 100%;
  overflow: auto;
}

.holder input {
  width: 100%;
  box-sizing: border-box;
}

.holder .txt_btn {
  font-size: 23px;
}

.thanks {
  text-align: center;
}

.loader {
  width: 200px !important;
  margin: auto;
}

.holder {
  padding: 50px;
}

.holder p {
  line-height: 1.2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade_delay-enter-active,
.fade_delay-leave-active {
  transition: opacity 0.5s;
  transition-delay: 0.5s;
}
.fade_delay-enter, .fade_delay-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.full-btn {
  background: #3581ef;
  width: 100%;
  max-width: 600px;
  position: relative;
  z-index: 3;
  color: white;
  text-align: center;
  font-weight: bold;
  padding: 15px;
  cursor: pointer;
  transition: background 0.3s;
}

.full-btn:hover {
  background: #2468ca;
}

.full-btn.error {
  pointer-events: none;
  background: white;
  color: #ed3a4a;
}

.loader {
  height: 60px;
  width: auto !important;
}
</style>
